module.exports = __webpack_public_path__ + "img/r-cb-off1.0cf7a7bd.gif";